import React from 'react';
import { LegalLinkItems } from './legalLinks';
import { Link, useNavigate } from 'react-router-dom';
import { openCookieSettings } from '../../utils/cookieConsent';
import '../../App.css';

function PrivacyPage() {
  const navigate = useNavigate();

  return (
    <div className="legal-page">
      <div className="legal-page__header">
        <button
          type="button"
          className="legal-page__back"
          onClick={() => (window.history.length > 1 ? navigate(-1) : navigate('/'))}
        >
          &larr; Назад
        </button>
        <Link to="/" className="legal-page__logo">Энилекс.Контроль</Link>
      </div>

      <div className="legal-page__content">
        <h1>Политика конфиденциальности</h1>
        <p className="legal-page__subtitle">Актуальная редакция о персональных данных и управлении аккаунтом</p>
        <p className="legal-page__date">Версия 2026-03-21, действует с 21 марта 2026 года</p>

        <section>
          <h2>1. Что регулирует эта политика</h2>
          <p>
            Политика описывает, какие данные Энилекс.Контроль собирает, зачем они нужны, кому могут
            передаваться и как пользователь может запросить экспорт или удаление аккаунта.
          </p>
          <p>
            Использование сервиса не считается автоматическим согласием на любые виды обработки.
            Для регистрации пользователь отдельно подтверждает акцепт оферты и ознакомление с этой политикой.
          </p>
        </section>

        <section>
          <h2>2. Какие данные мы собираем</h2>
          <ul>
            <li>данные профиля: email, имя, фамилия, телефон, Telegram ID при подключении;</li>
            <li>данные аккаунта и компании: роль, компания, настройки профиля и публичной страницы;</li>
            <li>технические данные: IP-адрес регистрации, user-agent, служебные логи безопасности;</li>
            <li>данные согласий: время подтверждения оферты, политики конфиденциальности и маркетинговых коммуникаций;</li>
            <li>данные, которые пользователь загружает в сервис: документы, переписка, рабочие материалы, настройки интеграций.</li>
          </ul>
        </section>

        <section>
          <h2>3. На каких основаниях мы обрабатываем данные</h2>
          <ul>
            <li>для исполнения договора и предоставления доступа к функциям сервиса;</li>
            <li>для соблюдения требований законодательства РФ;</li>
            <li>по отдельному согласию пользователя, если оно требуется;</li>
            <li>для маркетинговых сообщений только при отдельном дополнительном согласии.</li>
          </ul>
        </section>

        <section>
          <h2>4. Кому данные могут передаваться</h2>
          <p>Данные могут передаваться только в объёме, необходимом для работы сервиса, следующим категориям получателей:</p>
          <ul>
            <li>платёжным провайдерам;</li>
            <li>провайдерам аутентификации и OAuth;</li>
            <li>хостинг- и инфраструктурным подрядчикам;</li>
            <li>почтовым сервисам и сервисам транзакционных уведомлений;</li>
            <li>иным обработчикам по поручению оператора в рамках работы сервиса.</li>
          </ul>
        </section>

        <section>
          <h2>5. Файлы cookie и иные локальные данные браузера</h2>
          <p>
            Сервис использует не только файлы cookie, но и иные локальные данные браузера, включая
            localStorage и sessionStorage. Такая информация нужна для авторизации, безопасности,
            сохранения пользовательской сессии и корректной работы интерфейсов.
          </p>
          <p>К технически необходимым данным относятся:</p>
          <ul>
            <li>токен доступа и токен обновления сессии после входа в аккаунт;</li>
            <li>признаки активной пользовательской сессии и служебные флаги перенаправления;</li>
            <li>сохранённая тема интерфейса и иные настройки отображения, нужные для работы кабинета;</li>
            <li>локальные технические параметры отдельных экранов и модулей платформы.</li>
          </ul>
          <p>
            Технически необходимые cookie и локальные данные применяются без отдельного согласия,
            поскольку без них невозможны вход в аккаунт, защита сессии и предоставление базового
            функционала платформы.
          </p>
          <p>
            Отдельные аналитические или диагностические инструменты, не являющиеся строго
            необходимыми, могут включаться только после отдельного выбора пользователя в cookie
            banner. Если такие инструменты активированы, они используются для анализа стабильности
            сервиса и ошибок, в том числе через Sentry или аналогичные средства мониторинга.
          </p>
          <p>
            На момент публикации этой версии политики маркетинговые cookie для поведенческой рекламы
            в пользовательском интерфейсе seller.anylex.ru не заявляются как обязательная часть
            сервиса.
          </p>
          <p>
            Пользователь может отказаться от необязательных аналитических cookie через соответствующий
            banner и позднее отозвать такой выбор путём очистки cookie, localStorage и sessionStorage
            в браузере либо через будущую настройку управления cookie, если она доступна в интерфейсе.
            Выход из аккаунта прекращает использование токенов текущей сессии, но не заменяет очистку
            браузерных данных на стороне пользователя.
          </p>
          <button
            type="button"
            className="legal-page__action-button"
            onClick={openCookieSettings}
          >
            Открыть настройки cookie
          </button>
        </section>

        <section>
          <h2>6. Экспорт данных и удаление аккаунта</h2>
          <p>
            В настройках аккаунта доступны действия для выгрузки данных и подачи запроса на удаление аккаунта.
            После подтверждения удаления доступ к сервису может быть ограничен сразу, а полное завершение
            процесса может занять до 30 дней.
          </p>
          <p>
            Часть данных может храниться дольше, если это требуется по закону или нужно для бухгалтерского,
            налогового и правового учёта, а также для защиты законных интересов оператора.
          </p>
        </section>

        <section>
          <h2>7. Как связаться с нами</h2>
          <div className="legal-page__requisites">
            <p><strong>Email:</strong> control@anylex.ru</p>
          </div>
        </section>

        <section>
          <h2>8. Изменения документа</h2>
          <p>
            Новые редакции публикуются на этой странице с указанием версии и даты вступления в силу.
            Исторические согласия пользователей фиксируются с версией документов на момент регистрации.
          </p>
        </section>
      </div>

      <div className="legal-page__footer">
        <Link to="/">Вернуться на главную</Link>
        <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "6px 18px", marginTop: 12 }}>
          <LegalLinkItems short />
        </div>
      </div>
    </div>
  );
}

export default PrivacyPage;
